import { gql } from '@apollo/client'

/**
 * GraphQL query to get product family and product type auto-suggestions.
 *
 * This query supports searching for both families and product types
 * depending on the input parameters.
 */
export const GetPplFamilyAndPtAutoSuggest = gql`
    query getPPLFamilyAndPTAutoSuggest($input: PPLFamilyAutosuggestInput!) {
        getPPLFamilyAndPTAutoSuggest(input: $input) {
            result
        }
    }
`

/**
 * Input parameters for the PPL family and product type auto-suggest query
 */
export interface PPLFamilyAndPTAutoSuggestInput {
    searchText: string
    maxResults: number
    /** Whether to search for product types (true) or families (false) */
    searchProductTypes: boolean
    /** Optional family name when searching for product types within a specific family */
    productFamilyName?: string
}

/**
 * Result structure for the PPL family and product type auto-suggest query
 */
export interface PPLFamilyAndPTAutoSuggestResult {
    getPPLFamilyAndPTAutoSuggest: {
        result: string[]
    }
}
